import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import SentryFallback from "./components/SentryFallback";
import { POSTHOG_KEY, posthogOptions } from "./lib/posthog";

initSentry();

createRoot(document.getElementById("root")!).render(

  <Sentry.ErrorBoundary fallback={(props) => <SentryFallback {...props} />}>
    <HelmetProvider>
      <PostHogProvider apiKey={POSTHOG_KEY} options={posthogOptions}>
        <App />
      </PostHogProvider>
    </HelmetProvider>

  </Sentry.ErrorBoundary>
);
